import React from 'react';

import { Space } from 'antd-v5';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from 'scouting-ui/lib';

import styles from './UploadStats.less';

const UploadStats: React.FC<{
  className?: string;
  uploadedCount: number;
  onNavigateToHistory: () => void;
}> = props => {
  const { className, uploadedCount, onNavigateToHistory } = props;

  return (
    <div className={cn(styles.container, className)}>
      <Text color="color-white" font="body-body-2">
        {uploadedCount > 0 ? (
          <FormattedMessage
            id="advancementUpload.UploadStats.uploads"
            values={{ count: uploadedCount }}
          />
        ) : (
          <FormattedMessage id="advancementUpload.UploadStats.noUploads" />
        )}
      </Text>
      <Space direction="vertical" size={0}>
        <Text font="body-caption" color="color-white">
          <FormattedMessage id="advancementUpload.UploadStats.processing" />
        </Text>
        <Text font="body-caption" color="color-white">
          <FormattedMessage id="advancementUpload.UploadStats.visitTab" />
        </Text>
      </Space>
      <Button type="default" size="small" onClick={onNavigateToHistory}>
        <FormattedMessage id="advancementUpload.UploadStats.checkLog" />
      </Button>
    </div>
  );
};

export default UploadStats;
